import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HostService } from './host.service';
import { HttpClient, HttpEvent, HttpHandler, HttpHeaders, HttpRequest } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CarsService {
  dialogresponse: any;
  elt = [];
  src: any;

  headers = new HttpHeaders();
  private user = [
    {
      id: 1,
     user_name: '',
      cni: '',
      surname: '',
      adresse: '',
      city: '',
      email: '1233@gmail.com',
      tel: '691638011',

    },
  ]
  HttpClient: any;
  constructor(
        private https: HttpClient,
    private matDialog: MatDialog,
    private getHost: HostService
    ) { }
  
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

      return next.handle(req).pipe(
        catchError((error) => {
          console.log('error is intercept')
          console.error(error);
          return throwError(error.message);
        })
      )
    }
    
  CreateCar(cars: any) {
    // console.log(customer);
    return this.https.post(this.getHost.gethttps() + 'createCars',cars, );
  }

  getCars() {
    return this.https.get(this.getHost.gethttps() + 'cars', { withCredentials: true });
  }

  delete(cars: number,): Observable<any> {

    return this.https.post(this.getHost.gethttps() + 'deleteCars', { id: cars }, { withCredentials: true });
  }
  
  UpdateCars(datas: any) {
    return this.https.post(this.getHost.gethttps() + 'updateCars', datas, { withCredentials: true });
  }
  
  // use by Jonathan

    CreateDisponibility(dispo: any) {
      return this.https.post(this.getHost.gethttps() + 'CreateDisponibility',dispo);
    }

    week() {
      return this.https.get(this.getHost.gethttps() + 'week');
    }

    dispoDay() {
      return this.https.get(this.getHost.gethttps() + 'dispoDay');
    }

    getDispoHour(user:any){
      return this.https.post(this.getHost.gethttps() + 'getdispoDay',user);
    }
  //end use

  suprimeDispo(del: any) {
    // console.log(customer);
    return this.https.post(this.getHost.gethttps() + 'suprimeDispo',del);
  }

  CreateDisponibilityServiceHours(dispo: any) {
    // console.log(customer);
    return this.https.post(this.getHost.gethttps() + 'CreateDisponibilityServiceHours',dispo);
  }

  Creermadisponibilite(dispo: any) {
    return this.https.post(this.getHost.gethttps() + 'Creermadisponibilite',dispo);

  }
  CreateDispoHours(dispo: any) {
    // console.log(customer);
    return this.https.post(this.getHost.gethttps() + 'CreateDispoHours',dispo);
  }
 
  updateDispoHours(dispo: any) {
    // console.log(customer);
    return this.https.post(this.getHost.gethttps() + 'updateDispoHours',dispo);
  }

  updateDispoHoursFin(dispo: any) {
    // console.log(customer);
    return this.https.post(this.getHost.gethttps() + 'updateDispoHoursFin',dispo);
  }

  updateDayDB(dispo: any) {
    // console.log(customer);
    return this.https.post(this.getHost.gethttps() + 'updateDayDB',dispo);
  }
  CreateDispoHoursFin(dispo: any) {
    // console.log(customer);
    return this.https.post(this.getHost.gethttps() + 'CreateDispoHoursFin',dispo);
  }
   
  
  GetDisponibility(data:any) {
    let obj = {
      val:data
    }
    //  console.log(data);
    return this.https.post(this.getHost.gethttps() + "GetDisponobility" ,  obj);
  }
  GetDispoHours(data:any) {
      
    return this.https.post(this.getHost.gethttps() + 'GetDispoHours', data  ) ;
  }
  UpDisponibility(data:any) {
    // console.log(data);
   return this.https.post(this.getHost.gethttps() + 'UpDisponibility' , data);
 }

 //affiche all vehicule assurance

 valeur_assurance() {
  // console.log(customer);
  return this.https.get(this.getHost.gethttps() + 'valeur_assurance');
}

// disponibilites ajouter
Adddisponibilites(data:any) { 
 return this.https.post(this.getHost.gethttps() + 'Adddisponibilites' , data);
}

// disponibilites recuper
Recupdisponibilites(data:any) { 
  return this.https.post(this.getHost.gethttps() + 'Recupdisponibilites' , data);
 }

}
